'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
require('styled-components');
require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('../icon.js');
require('../browser-05a2bba8.js');
require('react-dom');
require('../_commonjsHelpers-3fc1f64e.js');
require('../_react_commonjs-external-30e5c7b3.js');
require('../_prop-types_commonjs-external-c51b2bd5.js');
var isFunction = _interopDefault(require('lodash/isFunction'));
require('../react-lifecycles-compat.es-59afd828.js');
require('../_react-dom_commonjs-external-3c49a59a.js');
require('../index-cd777c24.js');
var styles = require('../styles-777d0fe6.js');

var RentSpreeBaseImageModal = function RentSpreeBaseImageModal(_ref) {
  var id = _ref.id,
      rootId = _ref.rootId,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      modalSize = _ref.modalSize,
      imageSize = _ref.imageSize,
      shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnEsc = _ref.shouldCloseOnEsc,
      onAfterOpen = _ref.onAfterOpen,
      onAfterClose = _ref.onAfterClose,
      closeButton = _ref.closeButton,
      children = _ref.children,
      padding = _ref.padding,
      mPadding = _ref.mPadding,
      overflow = _ref.overflow,
      mOverflow = _ref.mOverflow,
      _ref$isConfirm = _ref.isConfirm,
      isConfirm = _ref$isConfirm === undefined ? false : _ref$isConfirm,
      imgSrc = _ref.imgSrc,
      backgroundColor = _ref.backgroundColor,
      objectFit = _ref.objectFit,
      _ref$hasBorder = _ref.hasBorder,
      hasBorder = _ref$hasBorder === undefined ? true : _ref$hasBorder,
      mFullPage = _ref.mFullPage;

  var disabledScrolling = function disabledScrolling() {
    if (isFunction(onAfterOpen)) {
      onAfterOpen();
    }
    document.body.style.overflow = "hidden";
  };
  var enabledScrolling = function enabledScrolling() {
    if (isFunction(onAfterClose)) {
      onAfterClose();
    }
    document.body.style.overflow = "auto";
    document.body.style.paddingRight = "0";
  };
  return React__default.createElement(
    styles.StyledModal,
    {
      id: id,
      rootId: rootId,
      contentLabel: id,
      isOpen: isOpen,
      onAfterOpen: disabledScrolling,
      onRequestClose: onClose,
      shouldCloseOnEsc: shouldCloseOnEsc,
      shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
      onAfterClose: enabledScrolling,
      closeTimeoutMS: 300,
      modalSize: modalSize,
      padding: padding,
      mPadding: mPadding,
      isConfirm: isConfirm,
      overflow: overflow,
      mOverflow: mOverflow,
      hasBorder: hasBorder,
      mFullPage: mFullPage },
    closeButton && React__default.createElement(
      styles.CloseButtonWrapper,
      { onClick: onClose },
      React__default.createElement(icon.Icon, { name: "close", size: "sm" })
    ),
    React__default.createElement(
      styles.ImageModalWrapper,
      { mFullPage: mFullPage },
      React__default.createElement(styles.ImageCover, {
        src: imgSrc,
        imageSize: imageSize,
        backgroundColor: backgroundColor,
        objectFit: objectFit
      }),
      React__default.createElement(
        "div",
        { className: "rentspree-base-modal-wrapper" },
        children
      )
    )
  );
};

RentSpreeBaseImageModal.propTypes = {
  /** size of modal */
  modalSize: PropTypes$1.string,
  /** size of image  */
  imageSize: PropTypes$1.string,
  /** id of the modal */
  id: PropTypes$1.string,
  /** indicator to show modal */
  isOpen: PropTypes$1.bool.isRequired,
  /** function that will get call after the modal is open */
  onAfterOpen: PropTypes$1.func,
  /** function that will get call when close modal */
  onClose: PropTypes$1.func.isRequired,
  /** indicator for call close modal function when click on overlay */
  shouldCloseOnOverlayClick: PropTypes$1.bool,
  /** indicator for show close button on the top right */
  closeButton: PropTypes$1.bool,
  /** indicator for close modal when press ESC */
  shouldCloseOnEsc: PropTypes$1.bool,
  /** function that will get call after the modal is close */
  onAfterClose: PropTypes$1.func,
  /** id of the root of your app. The modal need the root id to mount itself to the root component */
  rootId: PropTypes$1.string,
  /** padding style of the modal */
  padding: PropTypes$1.string,
  /** padding style of the modal on mobile view */
  mPadding: PropTypes$1.string,
  /** overflow behavior */
  overflow: PropTypes$1.string,
  /** overflow behavior on mobile view */
  mOverflow: PropTypes$1.string,
  /** src for image */
  imgSrc: PropTypes$1.string,
  /** background for image */
  backgroundColor: PropTypes$1.string,
  /** object fit for image */
  objectFit: PropTypes$1.string,
  /** Has border of modal */
  hasBorder: PropTypes$1.bool,
  /** Mobile full page modal */
  mFullPage: PropTypes$1.bool
};

RentSpreeBaseImageModal.defaultProps = {
  modalSize: "medium",
  imageSize: "40%",
  shouldCloseOnOverlayClick: true,
  closeButton: true,
  shouldCloseOnEsc: true,
  rootId: "#app",
  mPadding: "20px",
  hasBorder: true
};
RentSpreeBaseImageModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RentSpreeBaseImageModal",
  "props": {
    "isConfirm": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "hasBorder": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Has border of modal"
    },
    "modalSize": {
      "defaultValue": {
        "value": "\"medium\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "size of modal"
    },
    "imageSize": {
      "defaultValue": {
        "value": "\"40%\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "size of image"
    },
    "shouldCloseOnOverlayClick": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for call close modal function when click on overlay"
    },
    "closeButton": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for show close button on the top right"
    },
    "shouldCloseOnEsc": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for close modal when press ESC"
    },
    "rootId": {
      "defaultValue": {
        "value": "\"#app\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "id of the root of your app. The modal need the root id to mount itself to the root component"
    },
    "mPadding": {
      "defaultValue": {
        "value": "\"20px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "padding style of the modal on mobile view"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "id of the modal"
    },
    "isOpen": {
      "type": {
        "name": "bool"
      },
      "required": true,
      "description": "indicator to show modal"
    },
    "onAfterOpen": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that will get call after the modal is open"
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "function that will get call when close modal"
    },
    "onAfterClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that will get call after the modal is close"
    },
    "padding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "padding style of the modal"
    },
    "overflow": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "overflow behavior"
    },
    "mOverflow": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "overflow behavior on mobile view"
    },
    "imgSrc": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "src for image"
    },
    "backgroundColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "background for image"
    },
    "objectFit": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "object fit for image"
    },
    "mFullPage": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Mobile full page modal"
    }
  }
};

module.exports = RentSpreeBaseImageModal;
//# sourceMappingURL=image-modal.js.map
